import { USER_INITIAL_LOCATION, HOTELIER_INITIAL_LOCATION } from './initialLocation.types';
export const setUserInitialLocation = value => ({
    type: USER_INITIAL_LOCATION,
    payload: value,
});
export const setHotelierInitialLocation = value => ({
    type: HOTELIER_INITIAL_LOCATION,
    payload: value,
});
